"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SalesDashboardReportRowDTO_1 = require("../model/SalesDashboardReportRowDTO");

var SalesDashboardReportRowDTOConverter_1 = require("./SalesDashboardReportRowDTOConverter");

var SalesDashboardReportRowDTOConverterImpl =
/*#__PURE__*/
function (_SalesDashboardReport) {
  _inherits(SalesDashboardReportRowDTOConverterImpl, _SalesDashboardReport);

  function SalesDashboardReportRowDTOConverterImpl() {
    _classCallCheck(this, SalesDashboardReportRowDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SalesDashboardReportRowDTOConverterImpl).apply(this, arguments));
  }

  _createClass(SalesDashboardReportRowDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SalesDashboardReportRowDTO_1.SalesDashboardReportRowDTO(SalesDashboardReportRowDTO_1.SalesDashboardReportRowDTO.schema.id.valueOfField(source), SalesDashboardReportRowDTO_1.SalesDashboardReportRowDTO.schema.level.valueOfField(source), SalesDashboardReportRowDTO_1.SalesDashboardReportRowDTO.schema.isGroup.valueOfField(source), SalesDashboardReportRowDTO_1.SalesDashboardReportRowDTO.schema.entity.valueOfField(source), SalesDashboardReportRowDTO_1.SalesDashboardReportRowDTO.schema.title.valueOfField(source), SalesDashboardReportRowDTO_1.SalesDashboardReportRowDTO.schema.regularKpiValues.valueOf(source.regularKpiValues ? this.convertKpiValues(source.regularKpiValues, conversions) : null), SalesDashboardReportRowDTO_1.SalesDashboardReportRowDTO.schema.regularKpiValuesDeltas.valueOf(source.regularKpiValuesDeltas ? this.convertKpiValues(source.regularKpiValuesDeltas, conversions) : null), SalesDashboardReportRowDTO_1.SalesDashboardReportRowDTO.schema.leafletKpiValues.valueOf(source.leafletKpiValues ? this.convertKpiValues(source.leafletKpiValues, conversions) : null), SalesDashboardReportRowDTO_1.SalesDashboardReportRowDTO.schema.leafletKpiValuesDeltas.valueOf(source.leafletKpiValuesDeltas ? this.convertKpiValues(source.leafletKpiValuesDeltas, conversions) : null), SalesDashboardReportRowDTO_1.SalesDashboardReportRowDTO.schema.nonLeafletKpiValues.valueOf(source.nonLeafletKpiValues ? this.convertKpiValues(source.nonLeafletKpiValues, conversions) : null), SalesDashboardReportRowDTO_1.SalesDashboardReportRowDTO.schema.nonLeafletKpiValuesDeltas.valueOf(source.nonLeafletKpiValuesDeltas ? this.convertKpiValues(source.nonLeafletKpiValuesDeltas, conversions) : null), SalesDashboardReportRowDTO_1.SalesDashboardReportRowDTO.schema.totalKpiValues.valueOf(source.totalKpiValues ? this.convertKpiValues(source.totalKpiValues, conversions) : null), SalesDashboardReportRowDTO_1.SalesDashboardReportRowDTO.schema.totalKpiValuesDeltas.valueOf(source.totalKpiValuesDeltas ? this.convertKpiValues(source.totalKpiValuesDeltas, conversions) : null), SalesDashboardReportRowDTO_1.SalesDashboardReportRowDTO.schema.regNonLeafletKpiValues.valueOf(source.regNonLeafletKpiValues ? this.convertKpiValues(source.regNonLeafletKpiValues, conversions) : null), SalesDashboardReportRowDTO_1.SalesDashboardReportRowDTO.schema.regNonLeafletKpiValuesDeltas.valueOf(source.regNonLeafletKpiValuesDeltas ? this.convertKpiValues(source.regNonLeafletKpiValuesDeltas, conversions) : null));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        level: source.level,
        isGroup: source.isGroup,
        entity: source.entity ? source.entity : null,
        title: source.title ? source.title : null,
        regularKpiValues: source.regularKpiValues ? source.regularKpiValues : null,
        regularKpiValuesDeltas: source.regularKpiValuesDeltas ? source.regularKpiValuesDeltas : null,
        leafletKpiValues: source.leafletKpiValues ? source.leafletKpiValues : null,
        leafletKpiValuesDeltas: source.leafletKpiValuesDeltas ? source.leafletKpiValuesDeltas : null,
        nonLeafletKpiValues: source.nonLeafletKpiValues ? source.nonLeafletKpiValues : null,
        nonLeafletKpiValuesDeltas: source.nonLeafletKpiValuesDeltas ? source.nonLeafletKpiValuesDeltas : null,
        totalKpiValues: source.totalKpiValues ? source.totalKpiValues : null,
        totalKpiValuesDeltas: source.totalKpiValuesDeltas ? source.totalKpiValuesDeltas : null,
        regNonLeafletKpiValues: source.regNonLeafletKpiValues ? source.regNonLeafletKpiValues : null,
        regNonLeafletKpiValuesDeltas: source.regNonLeafletKpiValuesDeltas ? source.regNonLeafletKpiValuesDeltas : null
      });
      return result;
    }
  }, {
    key: "convertKpiValues",
    value: function convertKpiValues(sourceObj, conversions) {
      var kpis = {};

      if (sourceObj) {
        Object.keys(sourceObj).forEach(function (key) {
          var value = sourceObj[key];

          if (value) {
            kpis[key] = conversions.toBigNumber(value.value);
          }
        });
      }

      return kpis;
    }
  }]);

  return SalesDashboardReportRowDTOConverterImpl;
}(SalesDashboardReportRowDTOConverter_1.SalesDashboardReportRowDTOConverter);

exports.SalesDashboardReportRowDTOConverterImpl = SalesDashboardReportRowDTOConverterImpl;